import request from "@/utils/request";

export function commit(data) {
  return request({ url: "/user/withdraw/commit", method: "post", data: data });
}

export function getList(data) {
  return request({ url: "/user/withdraw/list", method: "post", data: data });
}

export function getTodayWithdrawTimes() {
  return request({ url: "/user/withdraw/getTodayTimes", method: "post" });
}

export function withdrawToUser(data) {
  return request({
    url: "/user/withdraw/withdrawToUser",
    method: "post",
    data: data,
  });
}
